<template>
  <v-container fluid py-0>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-container fluid pt-0>
          <v-row align="center">
            <div>
              <h1 class="headline">Client Statuses</h1>
            </div>
            <div>
              <v-tooltip
                v-if="$store.getters.hasAccessTo('clients:create')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-2"
                    fab
                    dark
                    color="primary"
                    @click="onCreateNew"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Client Status</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      :search="search"
      item-key="id"
      class="elevation-1"
      v-bind="pagingOptions"
      fixed-header
      hide-default-footer
      @update:options="onListOptionsUpdate"
    >
      <template v-slot:item.notInUse="{ item }">
        <v-simple-checkbox
          v-model="item.notInUse"
          :disabled="true"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.isDefault="{ item }">
        <v-simple-checkbox
          v-model="item.isDefault"
          :disabled="true"
        ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <default-list-actions
          :item="item"
          :hide-view="true"
          :hide-remove="hideRemove"
          :hide-edit="hideEdit"
          @deleteItem="deleteItem"
          @editItem="editItem"
        ></default-list-actions>
      </template>
    </v-data-table>

    <get-more-results
      :first="first"
      @limitChange="onLimitChange"
      :items="clientStatuses"
      :totalItems="totalItems"
      :loading="$apollo.loading"
      :loadMoreEnabled="loadMoreEnabled"
      @loadMore="loadMore('clientStatuses')"
    ></get-more-results>
    <edit-client-status-dialog
      v-model="editedClientStatus"
      :show="showClientStatusEditor"
      @close="showClientStatusEditor = false"
      @input="onSave"
    ></edit-client-status-dialog>
  </v-container>
</template>
<script>
import { ListMixin } from "../../../mixins/ListMixin";
import { ALL_CLIENT_STATUSES_SEARCH_QUERY } from "../../../constants/graphql";
import GetMoreResults from "../shared/GetMoreResults";
import DefaultListActions from "../shared/DefaultListActions";
import EditClientStatusDialog from "./EditClientStatusDialog";
import { removeGQLTypename } from "../../../helpers";
import gql from "graphql-tag";

const DELETE_MUTATION = gql`
  mutation deleteClientStatus($id: ID!) {
    deleteClientStatus(id: $id) {
      id
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createClientStatus($input: ClientStatusInput!) {
    createClientStatus(input: $input) {
      id
      name
      notInUse
      isDefault
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateClientStatus($id: ID!, $input: ClientStatusInput!) {
    updateClientStatus(id: $id, input: $input) {
      id
      name
      notInUse
      isDefault
    }
  }
`;

export default {
  name: "ClientStatusesList",
  mixins: [ListMixin],
  components: {
    GetMoreResults,
    DefaultListActions,
    EditClientStatusDialog,
  },

  data() {
    return {
      clientStatuses: {},
      editedClientStatus: {},
      showClientStatusEditor: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Is Default",
          value: "isDefault",
          name: "isDefault",
        },
        {
          text: "Not In Use",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.clientStatuses && this.clientStatuses.edges
        ? this.clientStatuses.edges.map(removeGQLTypename)
        : [];
    },
    hideRemove() {
      return !this.$store.getters.hasAccessTo("clients:delete");
    },
    hideEdit() {
      return !this.$store.getters.hasAccessTo("clients:edit");
    },
  },

  methods: {
    async onSave(payload) {
      this.showClientStatusEditor = false;
      const { id, ...input } = payload;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...input }, id },
        });
        this.$apollo.queries.clientStatuses.refetch();
        this.$store.dispatch("showAppSnackbar", {
          msg: "Client Type saved.",
        });
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.editedClientStatus = { ...item };
      this.showClientStatusEditor = true;
    },
    onCreateNew() {
      this.editedClientStatus = { name: "New Client Status" };
      this.showClientStatusEditor = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: item.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Client Type removed." });

      if (this.$apollo.queries.clientStatuses != null) {
        this.$apollo.queries.clientStatuses.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
      //console.log(err);
    },
  },

  apollo: {
    clientStatuses: {
      query: ALL_CLIENT_STATUSES_SEARCH_QUERY,
      variables() {
        return {
          after: this.after,
          sort: this.sort,
        };
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.totalItems = data.clientStatuses.totalCount;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/gt/clients/ClientStatusesList.vue